import { EsimCountry } from "@/lib/redux/features/esim/types";
import { removeVietnameseChars } from "@/utils/string/removeVietnameseChars";

export const filterEsimCountries = (
  countries: EsimCountry[],
  query: string,
): EsimCountry[] => {
  const normalized = removeVietnameseChars(query).trim().toLowerCase();
  if (!normalized) {
    return countries;
  }

  return countries.filter((country) => {
    const haystack = removeVietnameseChars(
      `${country.countryName} ${country.continent} ${country.capital} ${country.code}`,
    ).toLowerCase();
    return haystack.includes(normalized);
  });
};
